export const SEARCH_USERS_WATCHER = 'SEARCH_USERS_WATCHER';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_FAILED = 'SEARCH_USERS_FAILED';
